import e, { isAxiosError as t } from "axios";
import { useMemo as n } from "react";
//#region ../backend-config/dist/index.es.js
var r = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function i(e) {
	return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var a = function(e) {
	try {
		return !!e();
	} catch {
		return !0;
	}
}, o = !a(function() {
	var e = (function() {}).bind();
	return typeof e != "function" || e.hasOwnProperty("prototype");
}), s = o, c = Function.prototype, l = c.call, u = s && c.bind.bind(l, l), d = s ? u : function(e) {
	return function() {
		return l.apply(e, arguments);
	};
}, f = d({}.isPrototypeOf), p = function(e) {
	return e && e.Math === Math && e;
}, m = p(typeof globalThis == "object" && globalThis) || p(typeof window == "object" && window) || p(typeof self == "object" && self) || p(typeof r == "object" && r) || (function() {
	return this;
})() || r || Function("return this")(), h = o, g = Function.prototype, _ = g.apply, v = g.call, y = typeof Reflect == "object" && Reflect.apply || (h ? v.bind(_) : function() {
	return v.apply(_, arguments);
}), ee = d, te = ee({}.toString), ne = ee("".slice), b = function(e) {
	return ne(te(e), 8, -1);
}, re = b, ie = d, ae = function(e) {
	if (re(e) === "Function") return ie(e);
}, oe = typeof document == "object" && document.all, se = {
	all: oe,
	IS_HTMLDDA: oe === void 0 && oe !== void 0
}, ce = se, le = ce.all, x = ce.IS_HTMLDDA ? function(e) {
	return typeof e == "function" || e === le;
} : function(e) {
	return typeof e == "function";
}, ue = {}, S = !a(function() {
	return Object.defineProperty({}, 1, { get: function() {
		return 7;
	} })[1] !== 7;
}), de = o, fe = Function.prototype.call, C = de ? fe.bind(fe) : function() {
	return fe.apply(fe, arguments);
}, pe = {}, me = {}.propertyIsEnumerable, he = Object.getOwnPropertyDescriptor;
pe.f = he && !me.call({ 1: 2 }, 1) ? function(e) {
	var t = he(this, e);
	return !!t && t.enumerable;
} : me;
var ge = function(e, t) {
	return {
		enumerable: !(e & 1),
		configurable: !(e & 2),
		writable: !(e & 4),
		value: t
	};
}, _e = d, ve = a, ye = b, be = Object, xe = _e("".split), Se = ve(function() {
	return !be("z").propertyIsEnumerable(0);
}) ? function(e) {
	return ye(e) === "String" ? xe(e, "") : be(e);
} : be, Ce = function(e) {
	return e == null;
}, we = Ce, Te = TypeError, Ee = function(e) {
	if (we(e)) throw Te("Can't call method on " + e);
	return e;
}, De = Se, Oe = Ee, w = function(e) {
	return De(Oe(e));
}, ke = x, Ae = se, je = Ae.all, T = Ae.IS_HTMLDDA ? function(e) {
	return typeof e == "object" ? e !== null : ke(e) || e === je;
} : function(e) {
	return typeof e == "object" ? e !== null : ke(e);
}, E = {}, Me = E, Ne = m, Pe = x, Fe = function(e) {
	return Pe(e) ? e : void 0;
}, Ie = function(e, t) {
	return arguments.length < 2 ? Fe(Me[e]) || Fe(Ne[e]) : Me[e] && Me[e][t] || Ne[e] && Ne[e][t];
}, Le = typeof navigator < "u" && String(navigator.userAgent) || "", Re = m, ze = Le, Be = Re.process, Ve = Re.Deno, He = Be && Be.versions || Ve && Ve.version, Ue = He && He.v8, D, We;
Ue && (D = Ue.split("."), We = D[0] > 0 && D[0] < 4 ? 1 : +(D[0] + D[1])), !We && ze && (D = ze.match(/Edge\/(\d+)/), (!D || D[1] >= 74) && (D = ze.match(/Chrome\/(\d+)/), D && (We = +D[1])));
var Ge = We, Ke = Ge, qe = a, Je = m.String, Ye = !!Object.getOwnPropertySymbols && !qe(function() {
	var e = Symbol("symbol detection");
	return !Je(e) || !(Object(e) instanceof Symbol) || !Symbol.sham && Ke && Ke < 41;
}), Xe = Ye && !Symbol.sham && typeof Symbol.iterator == "symbol", Ze = Ie, Qe = x, $e = f, et = Xe, tt = Object, nt = et ? function(e) {
	return typeof e == "symbol";
} : function(e) {
	var t = Ze("Symbol");
	return Qe(t) && $e(t.prototype, tt(e));
}, rt = String, it = function(e) {
	try {
		return rt(e);
	} catch {
		return "Object";
	}
}, at = x, ot = it, st = TypeError, ct = function(e) {
	if (at(e)) return e;
	throw st(ot(e) + " is not a function");
}, lt = ct, ut = Ce, dt = function(e, t) {
	var n = e[t];
	return ut(n) ? void 0 : lt(n);
}, ft = C, pt = x, mt = T, ht = TypeError, gt = function(e, t) {
	var n, r;
	if (t === "string" && pt(n = e.toString) && !mt(r = ft(n, e)) || pt(n = e.valueOf) && !mt(r = ft(n, e)) || t !== "string" && pt(n = e.toString) && !mt(r = ft(n, e))) return r;
	throw ht("Can't convert object to primitive value");
}, _t = { exports: {} }, vt = m, yt = Object.defineProperty, bt = function(e, t) {
	try {
		yt(vt, e, {
			value: t,
			configurable: !0,
			writable: !0
		});
	} catch {
		vt[e] = t;
	}
	return t;
}, xt = m, St = bt, Ct = "__core-js_shared__", wt = xt[Ct] || St(Ct, {}), Tt = wt;
(_t.exports = function(e, t) {
	return Tt[e] || (Tt[e] = t === void 0 ? {} : t);
})("versions", []).push({
	version: "3.32.1",
	mode: "pure",
	copyright: "© 2014-2023 Denis Pushkarev (zloirock.ru)",
	license: "https://github.com/zloirock/core-js/blob/v3.32.1/LICENSE",
	source: "https://github.com/zloirock/core-js"
});
var Et = _t.exports, Dt = Ee, Ot = Object, kt = function(e) {
	return Ot(Dt(e));
}, At = d, jt = kt, Mt = At({}.hasOwnProperty), O = Object.hasOwn || function(e, t) {
	return Mt(jt(e), t);
}, Nt = d, Pt = 0, Ft = Math.random(), It = Nt(1 .toString), Lt = function(e) {
	return "Symbol(" + (e === void 0 ? "" : e) + ")_" + It(++Pt + Ft, 36);
}, Rt = m, zt = Et, Bt = O, Vt = Lt, Ht = Ye, Ut = Xe, k = Rt.Symbol, Wt = zt("wks"), Gt = Ut ? k.for || k : k && k.withoutSetter || Vt, A = function(e) {
	return Bt(Wt, e) || (Wt[e] = Ht && Bt(k, e) ? k[e] : Gt("Symbol." + e)), Wt[e];
}, Kt = C, qt = T, Jt = nt, Yt = dt, Xt = gt, Zt = A, Qt = TypeError, $t = Zt("toPrimitive"), en = function(e, t) {
	if (!qt(e) || Jt(e)) return e;
	var n = Yt(e, $t), r;
	if (n) {
		if (t === void 0 && (t = "default"), r = Kt(n, e, t), !qt(r) || Jt(r)) return r;
		throw Qt("Can't convert object to primitive value");
	}
	return t === void 0 && (t = "number"), Xt(e, t);
}, tn = nt, nn = function(e) {
	var t = en(e, "string");
	return tn(t) ? t : t + "";
}, rn = m, an = T, on = rn.document, sn = an(on) && an(on.createElement), cn = function(e) {
	return sn ? on.createElement(e) : {};
}, ln = S, un = a, dn = cn, fn = !ln && !un(function() {
	return Object.defineProperty(dn("div"), "a", { get: function() {
		return 7;
	} }).a !== 7;
}), pn = S, mn = C, hn = pe, gn = ge, _n = w, vn = nn, yn = O, bn = fn, xn = Object.getOwnPropertyDescriptor;
ue.f = pn ? xn : function(e, t) {
	if (e = _n(e), t = vn(t), bn) try {
		return xn(e, t);
	} catch {}
	if (yn(e, t)) return gn(!mn(hn.f, e, t), e[t]);
};
var Sn = a, Cn = x, wn = /#|\.prototype\./, Tn = function(e, t) {
	var n = Dn[En(e)];
	return n === kn ? !0 : n === On ? !1 : Cn(t) ? Sn(t) : !!t;
}, En = Tn.normalize = function(e) {
	return String(e).replace(wn, ".").toLowerCase();
}, Dn = Tn.data = {}, On = Tn.NATIVE = "N", kn = Tn.POLYFILL = "P", An = Tn, jn = ae, Mn = ct, Nn = o, Pn = jn(jn.bind), Fn = function(e, t) {
	return Mn(e), t === void 0 ? e : Nn ? Pn(e, t) : function() {
		return e.apply(t, arguments);
	};
}, j = {}, In = S && a(function() {
	return Object.defineProperty(function() {}, "prototype", {
		value: 42,
		writable: !1
	}).prototype !== 42;
}), Ln = T, Rn = String, zn = TypeError, M = function(e) {
	if (Ln(e)) return e;
	throw zn(Rn(e) + " is not an object");
}, Bn = S, Vn = fn, Hn = In, Un = M, Wn = nn, Gn = TypeError, Kn = Object.defineProperty, qn = Object.getOwnPropertyDescriptor, Jn = "enumerable", Yn = "configurable", Xn = "writable";
j.f = Bn ? Hn ? function(e, t, n) {
	if (Un(e), t = Wn(t), Un(n), typeof e == "function" && t === "prototype" && "value" in n && Xn in n && !n[Xn]) {
		var r = qn(e, t);
		r && r[Xn] && (e[t] = n.value, n = {
			configurable: Yn in n ? n[Yn] : r[Yn],
			enumerable: Jn in n ? n[Jn] : r[Jn],
			writable: !1
		});
	}
	return Kn(e, t, n);
} : Kn : function(e, t, n) {
	if (Un(e), t = Wn(t), Un(n), Vn) try {
		return Kn(e, t, n);
	} catch {}
	if ("get" in n || "set" in n) throw Gn("Accessors not supported");
	return "value" in n && (e[t] = n.value), e;
};
var Zn = S, Qn = j, $n = ge, N = Zn ? function(e, t, n) {
	return Qn.f(e, t, $n(1, n));
} : function(e, t, n) {
	return e[t] = n, e;
}, er = m, tr = y, nr = ae, rr = x, ir = ue.f, ar = An, P = E, or = Fn, F = N, sr = O, cr = function(e) {
	var t = function(n, r, i) {
		if (this instanceof t) {
			switch (arguments.length) {
				case 0: return new e();
				case 1: return new e(n);
				case 2: return new e(n, r);
			}
			return new e(n, r, i);
		}
		return tr(e, this, arguments);
	};
	return t.prototype = e.prototype, t;
}, I = function(e, t) {
	var n = e.target, r = e.global, i = e.stat, a = e.proto, o = r ? er : i ? er[n] : (er[n] || {}).prototype, s = r ? P : P[n] || F(P, n, {})[n], c = s.prototype, l, u, d, f, p, m, h, g, _;
	for (f in t) l = ar(r ? f : n + (i ? "." : "#") + f, e.forced), u = !l && o && sr(o, f), m = s[f], u && (e.dontCallGetSet ? (_ = ir(o, f), h = _ && _.value) : h = o[f]), p = u && h ? h : t[f], !(u && typeof m == typeof p) && (g = e.bind && u ? or(p, er) : e.wrap && u ? cr(p) : a && rr(p) ? nr(p) : p, (e.sham || p && p.sham || m && m.sham) && F(g, "sham", !0), F(s, f, g), a && (d = n + "Prototype", sr(P, d) || F(P, d, {}), F(P[d], f, p), e.real && c && (l || !c[f]) && F(c, f, p)));
}, lr = Math.ceil, ur = Math.floor, dr = Math.trunc || function(e) {
	var t = +e;
	return (t > 0 ? ur : lr)(t);
}, fr = function(e) {
	var t = +e;
	return t !== t || t === 0 ? 0 : dr(t);
}, pr = fr, mr = Math.max, hr = Math.min, gr = function(e, t) {
	var n = pr(e);
	return n < 0 ? mr(n + t, 0) : hr(n, t);
}, _r = fr, vr = Math.min, yr = function(e) {
	return e > 0 ? vr(_r(e), 9007199254740991) : 0;
}, br = yr, xr = function(e) {
	return br(e.length);
}, Sr = w, Cr = gr, wr = xr, Tr = function(e) {
	return function(t, n, r) {
		var i = Sr(t), a = wr(i), o = Cr(r, a), s;
		if (e && n !== n) {
			for (; a > o;) if (s = i[o++], s !== s) return !0;
		} else for (; a > o; o++) if ((e || o in i) && i[o] === n) return e || o || 0;
		return !e && -1;
	};
}, Er = {
	includes: Tr(!0),
	indexOf: Tr(!1)
}, Dr = I, Or = Er.includes;
Dr({
	target: "Array",
	proto: !0,
	forced: a(function() {
		return ![,].includes();
	})
}, { includes: function(e) {
	return Or(this, e, arguments.length > 1 ? arguments[1] : void 0);
} });
var kr = E, Ar = function(e) {
	return kr[e + "Prototype"];
}, jr = Ar("Array").includes, Mr = T, Nr = b, Pr = A("match"), Fr = function(e) {
	var t;
	return Mr(e) && ((t = e[Pr]) === void 0 ? Nr(e) === "RegExp" : !!t);
}, Ir = TypeError, Lr = function(e) {
	if (Fr(e)) throw Ir("The method doesn't accept regular expressions");
	return e;
}, Rr = A("toStringTag"), zr = {};
zr[Rr] = "z";
var Br = String(zr) === "[object z]", Vr = Br, Hr = x, Ur = b, Wr = A("toStringTag"), Gr = Object, Kr = Ur(function() {
	return arguments;
}()) === "Arguments", qr = function(e, t) {
	try {
		return e[t];
	} catch {}
}, Jr = Vr ? Ur : function(e) {
	var t, n, r;
	return e === void 0 ? "Undefined" : e === null ? "Null" : typeof (n = qr(t = Gr(e), Wr)) == "string" ? n : Kr ? Ur(t) : (r = Ur(t)) === "Object" && Hr(t.callee) ? "Arguments" : r;
}, Yr = Jr, Xr = String, Zr = function(e) {
	if (Yr(e) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
	return Xr(e);
}, Qr = A("match"), $r = function(e) {
	var t = /./;
	try {
		"/./"[e](t);
	} catch {
		try {
			return t[Qr] = !1, "/./"[e](t);
		} catch {}
	}
	return !1;
}, ei = I, ti = d, ni = Lr, ri = Ee, ii = Zr, ai = $r, oi = ti("".indexOf);
ei({
	target: "String",
	proto: !0,
	forced: !ai("includes")
}, { includes: function(e) {
	return !!~oi(ii(ri(this)), ii(ni(e)), arguments.length > 1 ? arguments[1] : void 0);
} });
var si = Ar("String").includes, ci = f, li = jr, ui = si, di = Array.prototype, fi = String.prototype, L = /*@__PURE__*/ i(function(e) {
	var t = e.includes;
	return e === di || ci(di, e) && t === di.includes ? li : typeof e == "string" || e === fi || ci(fi, e) && t === fi.includes ? ui : t;
}), pi = b, mi = Array.isArray || function(e) {
	return pi(e) === "Array";
}, hi = d, gi = x, _i = wt, vi = hi(Function.toString);
gi(_i.inspectSource) || (_i.inspectSource = function(e) {
	return vi(e);
});
var yi = _i.inspectSource, bi = d, xi = a, Si = x, Ci = Jr, wi = Ie, Ti = yi, Ei = function() {}, Di = [], Oi = wi("Reflect", "construct"), ki = /^\s*(?:class|function)\b/, Ai = bi(ki.exec), ji = !ki.exec(Ei), Mi = function(e) {
	if (!Si(e)) return !1;
	try {
		return Oi(Ei, Di, e), !0;
	} catch {
		return !1;
	}
}, Ni = function(e) {
	if (!Si(e)) return !1;
	switch (Ci(e)) {
		case "AsyncFunction":
		case "GeneratorFunction":
		case "AsyncGeneratorFunction": return !1;
	}
	try {
		return ji || !!Ai(ki, Ti(e));
	} catch {
		return !0;
	}
};
Ni.sham = !0;
var Pi = !Oi || xi(function() {
	var e;
	return Mi(Mi.call) || !Mi(Object) || !Mi(function() {
		e = !0;
	}) || e;
}) ? Ni : Mi, Fi = mi, Ii = Pi, Li = T, Ri = A("species"), zi = Array, Bi = function(e) {
	var t;
	return Fi(e) && (t = e.constructor, Ii(t) && (t === zi || Fi(t.prototype)) ? t = void 0 : Li(t) && (t = t[Ri], t === null && (t = void 0))), t === void 0 ? zi : t;
}, Vi = function(e, t) {
	return new (Bi(e))(t === 0 ? 0 : t);
}, Hi = Fn, Ui = d, Wi = Se, Gi = kt, Ki = xr, qi = Vi, Ji = Ui([].push), Yi = function(e) {
	var t = e === 1, n = e === 2, r = e === 3, i = e === 4, a = e === 6, o = e === 7, s = e === 5 || a;
	return function(c, l, u, d) {
		for (var f = Gi(c), p = Wi(f), m = Hi(l, u), h = Ki(p), g = 0, _ = d || qi, v = t ? _(c, h) : n || o ? _(c, 0) : void 0, y, ee; h > g; g++) if ((s || g in p) && (y = p[g], ee = m(y, g, f), e)) if (t) v[g] = ee;
		else if (ee) switch (e) {
			case 3: return !0;
			case 5: return y;
			case 6: return g;
			case 2: Ji(v, y);
		}
		else switch (e) {
			case 4: return !1;
			case 7: Ji(v, y);
		}
		return a ? -1 : r || i ? i : v;
	};
}, Xi = {
	forEach: Yi(0),
	map: Yi(1),
	find: Yi(5)
}, Zi = I, Qi = Xi.find, $i = "find", ea = !0;
$i in [] && [,][$i](function() {
	ea = !1;
}), Zi({
	target: "Array",
	proto: !0,
	forced: ea
}, { find: function(e) {
	return Qi(this, e, arguments.length > 1 ? arguments[1] : void 0);
} });
var ta = Ar("Array").find, na = f, ra = ta, ia = Array.prototype, aa = /*@__PURE__*/ i(function(e) {
	var t = e.find;
	return e === ia || na(ia, e) && t === ia.find ? ra : t;
}), oa = I, sa = ae, ca = yr, la = Zr, ua = Lr, da = Ee, fa = $r, pa = sa("".startsWith), ma = sa("".slice), ha = Math.min;
oa({
	target: "String",
	proto: !0,
	forced: !fa("startsWith")
}, { startsWith: function(e) {
	var t = la(da(this));
	ua(e);
	var n = ca(ha(arguments.length > 1 ? arguments[1] : void 0, t.length)), r = la(e);
	return pa ? pa(t, r, n) : ma(t, n, n + r.length) === r;
} });
var ga = Ar("String").startsWith, _a = f, va = ga, ya = String.prototype, ba = /*@__PURE__*/ i(function(e) {
	var t = e.startsWith;
	return typeof e == "string" || e === ya || _a(ya, e) && t === ya.startsWith ? va : t;
}), R = {}, xa = m, Sa = x, Ca = xa.WeakMap, wa = Sa(Ca) && /native code/.test(String(Ca)), Ta = Et, Ea = Lt, Da = Ta("keys"), Oa = function(e) {
	return Da[e] || (Da[e] = Ea(e));
}, ka = {}, Aa = wa, ja = m, Ma = T, Na = N, Pa = O, Fa = wt, Ia = Oa, La = ka, Ra = "Object already initialized", za = ja.TypeError, Ba = ja.WeakMap, Va, Ha, Ua, Wa = function(e) {
	return Ua(e) ? Ha(e) : Va(e, {});
}, Ga = function(e) {
	return function(t) {
		var n;
		if (!Ma(t) || (n = Ha(t)).type !== e) throw za("Incompatible receiver, " + e + " required");
		return n;
	};
};
if (Aa || Fa.state) {
	var z = Fa.state ||= new Ba();
	z.get = z.get, z.has = z.has, z.set = z.set, Va = function(e, t) {
		if (z.has(e)) throw za(Ra);
		return t.facade = e, z.set(e, t), t;
	}, Ha = function(e) {
		return z.get(e) || {};
	}, Ua = function(e) {
		return z.has(e);
	};
} else {
	var B = Ia("state");
	La[B] = !0, Va = function(e, t) {
		if (Pa(e, B)) throw za(Ra);
		return t.facade = e, Na(e, B, t), t;
	}, Ha = function(e) {
		return Pa(e, B) ? e[B] : {};
	}, Ua = function(e) {
		return Pa(e, B);
	};
}
var Ka = {
	set: Va,
	get: Ha,
	has: Ua,
	enforce: Wa,
	getterFor: Ga
}, qa = S, Ja = O, Ya = Function.prototype, Xa = qa && Object.getOwnPropertyDescriptor, Za = Ja(Ya, "name"), Qa = {
	PROPER: Za && (function() {}).name === "something",
	CONFIGURABLE: Za && (!qa || qa && Xa(Ya, "name").configurable)
}, $a = {}, eo = d, to = O, no = w, ro = Er.indexOf, io = ka, ao = eo([].push), oo = function(e, t) {
	var n = no(e), r = 0, i = [], a;
	for (a in n) !to(io, a) && to(n, a) && ao(i, a);
	for (; t.length > r;) to(n, a = t[r++]) && (~ro(i, a) || ao(i, a));
	return i;
}, so = [
	"constructor",
	"hasOwnProperty",
	"isPrototypeOf",
	"propertyIsEnumerable",
	"toLocaleString",
	"toString",
	"valueOf"
], co = oo, lo = so, uo = Object.keys || function(e) {
	return co(e, lo);
}, fo = S, po = In, mo = j, ho = M, go = w, _o = uo;
$a.f = fo && !po ? Object.defineProperties : function(e, t) {
	ho(e);
	for (var n = go(t), r = _o(t), i = r.length, a = 0, o; i > a;) mo.f(e, o = r[a++], n[o]);
	return e;
};
var vo = Ie("document", "documentElement"), yo = M, bo = $a, xo = so, So = ka, Co = vo, wo = cn, To = Oa, Eo = ">", Do = "<", Oo = "prototype", ko = "script", Ao = To("IE_PROTO"), jo = function() {}, Mo = function(e) {
	return Do + ko + Eo + e + Do + "/" + ko + Eo;
}, No = function(e) {
	e.write(Mo("")), e.close();
	var t = e.parentWindow.Object;
	return e = null, t;
}, Po = function() {
	var e = wo("iframe"), t = "java" + ko + ":", n;
	return e.style.display = "none", Co.appendChild(e), e.src = String(t), n = e.contentWindow.document, n.open(), n.write(Mo("document.F=Object")), n.close(), n.F;
}, Fo, Io = function() {
	try {
		Fo = new ActiveXObject("htmlfile");
	} catch {}
	Io = typeof document < "u" ? document.domain && Fo ? No(Fo) : Po() : No(Fo);
	for (var e = xo.length; e--;) delete Io[Oo][xo[e]];
	return Io();
};
So[Ao] = !0;
var Lo = Object.create || function(e, t) {
	var n;
	return e === null ? n = Io() : (jo[Oo] = yo(e), n = new jo(), jo[Oo] = null, n[Ao] = e), t === void 0 ? n : bo.f(n, t);
}, Ro = !a(function() {
	function e() {}
	return e.prototype.constructor = null, Object.getPrototypeOf(new e()) !== e.prototype;
}), zo = O, Bo = x, Vo = kt, Ho = Oa, Uo = Ro, Wo = Ho("IE_PROTO"), Go = Object, Ko = Go.prototype, qo = Uo ? Go.getPrototypeOf : function(e) {
	var t = Vo(e);
	if (zo(t, Wo)) return t[Wo];
	var n = t.constructor;
	return Bo(n) && t instanceof n ? n.prototype : t instanceof Go ? Ko : null;
}, Jo = N, Yo = function(e, t, n, r) {
	return r && r.enumerable ? e[t] = n : Jo(e, t, n), e;
}, Xo = a, Zo = x, Qo = T, $o = Lo, es = qo, ts = Yo, ns = A("iterator"), rs = !1, V, is, as;
[].keys && (as = [].keys(), "next" in as ? (is = es(es(as)), is !== Object.prototype && (V = is)) : rs = !0), V = !Qo(V) || Xo(function() {
	var e = {};
	return V[ns].call(e) !== e;
}) ? {} : $o(V), Zo(V[ns]) || ts(V, ns, function() {
	return this;
});
var os = {
	IteratorPrototype: V,
	BUGGY_SAFARI_ITERATORS: rs
}, ss = Br, cs = Jr, ls = ss ? {}.toString : function() {
	return "[object " + cs(this) + "]";
}, us = Br, ds = j.f, fs = N, ps = O, ms = ls, hs = A("toStringTag"), gs = function(e, t, n, r) {
	if (e) {
		var i = n ? e : e.prototype;
		ps(i, hs) || ds(i, hs, {
			configurable: !0,
			value: t
		}), r && !us && fs(i, "toString", ms);
	}
}, _s = os.IteratorPrototype, vs = Lo, ys = ge, bs = gs, xs = R, Ss = function() {
	return this;
}, Cs = function(e, t, n, r) {
	var i = t + " Iterator";
	return e.prototype = vs(_s, { next: ys(+!r, n) }), bs(e, i, !1, !0), xs[i] = Ss, e;
}, ws = d, Ts = ct, Es = function(e, t, n) {
	try {
		return ws(Ts(Object.getOwnPropertyDescriptor(e, t)[n]));
	} catch {}
}, Ds = x, Os = String, ks = TypeError, As = function(e) {
	if (typeof e == "object" || Ds(e)) return e;
	throw ks("Can't set " + Os(e) + " as a prototype");
}, js = Es, Ms = M, Ns = As;
Object.setPrototypeOf || "__proto__" in {} && function() {
	var e = !1, t = {}, n;
	try {
		n = js(Object.prototype, "__proto__", "set"), n(t, []), e = t instanceof Array;
	} catch {}
	return function(t, r) {
		return Ms(t), Ns(r), e ? n(t, r) : t.__proto__ = r, t;
	};
}();
var Ps = I, Fs = C, Is = Qa, Ls = Cs, Rs = qo, zs = gs, Bs = Yo, Vs = A, Hs = R, Us = os, Ws = Is.PROPER;
Is.CONFIGURABLE, Us.IteratorPrototype;
var Gs = Us.BUGGY_SAFARI_ITERATORS, Ks = Vs("iterator"), qs = "keys", Js = "values", Ys = "entries", Xs = function() {
	return this;
}, Zs = function(e, t, n, r, i, a, o) {
	Ls(n, t, r);
	var s = function(e) {
		if (e === i && f) return f;
		if (!Gs && e in u) return u[e];
		switch (e) {
			case qs: return function() {
				return new n(this, e);
			};
			case Js: return function() {
				return new n(this, e);
			};
			case Ys: return function() {
				return new n(this, e);
			};
		}
		return function() {
			return new n(this);
		};
	}, c = t + " Iterator", l = !1, u = e.prototype, d = u[Ks] || u["@@iterator"] || i && u[i], f = !Gs && d || s(i), p = t === "Array" && u.entries || d, m, h, g;
	if (p && (m = Rs(p.call(new e())), m !== Object.prototype && m.next && (zs(m, c, !0, !0), Hs[c] = Xs)), Ws && i === Js && d && d.name !== Js && (l = !0, f = function() {
		return Fs(d, this);
	}), i) if (h = {
		values: s(Js),
		keys: a ? f : s(qs),
		entries: s(Ys)
	}, o) for (g in h) (Gs || l || !(g in u)) && Bs(u, g, h[g]);
	else Ps({
		target: t,
		proto: !0,
		forced: Gs || l
	}, h);
	return o && u[Ks] !== f && Bs(u, Ks, f, {}), Hs[t] = f, h;
}, Qs = function(e, t) {
	return {
		value: e,
		done: t
	};
}, $s = w, ec = R, tc = Ka;
j.f;
var nc = Zs, rc = Qs, ic = "Array Iterator", ac = tc.set, oc = tc.getterFor(ic);
nc(Array, "Array", function(e, t) {
	ac(this, {
		type: ic,
		target: $s(e),
		index: 0,
		kind: t
	});
}, function() {
	var e = oc(this), t = e.target, n = e.kind, r = e.index++;
	if (!t || r >= t.length) return e.target = void 0, rc(void 0, !0);
	switch (n) {
		case "keys": return rc(r, !1);
		case "values": return rc(t[r], !1);
	}
	return rc([r, t[r]], !1);
}, "values"), ec.Arguments = ec.Array;
var sc = A, cc = R, lc = sc("iterator"), uc = Array.prototype, dc = function(e) {
	return e !== void 0 && (cc.Array === e || uc[lc] === e);
}, fc = Jr, pc = dt, mc = Ce, hc = R, gc = A("iterator"), _c = function(e) {
	if (!mc(e)) return pc(e, gc) || pc(e, "@@iterator") || hc[fc(e)];
}, vc = C, yc = ct, bc = M, xc = it, Sc = _c, Cc = TypeError, wc = function(e, t) {
	var n = arguments.length < 2 ? Sc(e) : t;
	if (yc(n)) return bc(vc(n, e));
	throw Cc(xc(e) + " is not iterable");
}, Tc = C, Ec = M, Dc = dt, Oc = function(e, t, n) {
	var r, i;
	Ec(e);
	try {
		if (r = Dc(e, "return"), !r) {
			if (t === "throw") throw n;
			return n;
		}
		r = Tc(r, e);
	} catch (e) {
		i = !0, r = e;
	}
	if (t === "throw") throw n;
	if (i) throw r;
	return Ec(r), n;
}, kc = Fn, Ac = C, jc = M, Mc = it, Nc = dc, Pc = xr, Fc = f, Ic = wc, Lc = _c, Rc = Oc, zc = TypeError, Bc = function(e, t) {
	this.stopped = e, this.result = t;
}, Vc = Bc.prototype, Hc = function(e, t, n) {
	var r = n && n.that, i = !!(n && n.AS_ENTRIES), a = !!(n && n.IS_RECORD), o = !!(n && n.IS_ITERATOR), s = !!(n && n.INTERRUPTED), c = kc(t, r), l, u, d, f, p, m, h, g = function(e) {
		return l && Rc(l, "normal", e), new Bc(!0, e);
	}, _ = function(e) {
		return i ? (jc(e), s ? c(e[0], e[1], g) : c(e[0], e[1])) : s ? c(e, g) : c(e);
	};
	if (a) l = e.iterator;
	else if (o) l = e;
	else {
		if (u = Lc(e), !u) throw zc(Mc(e) + " is not iterable");
		if (Nc(u)) {
			for (d = 0, f = Pc(e); f > d; d++) if (p = _(e[d]), p && Fc(Vc, p)) return p;
			return new Bc(!1);
		}
		l = Ic(e, u);
	}
	for (m = a ? e.next : l.next; !(h = Ac(m, l)).done;) {
		try {
			p = _(h.value);
		} catch (e) {
			Rc(l, "throw", e);
		}
		if (typeof p == "object" && p && Fc(Vc, p)) return p;
	}
	return new Bc(!1);
}, Uc = nn, Wc = j, Gc = ge, Kc = function(e, t, n) {
	var r = Uc(t);
	r in e ? Wc.f(e, r, Gc(0, n)) : e[r] = n;
}, qc = I, Jc = Hc, Yc = Kc;
qc({
	target: "Object",
	stat: !0
}, { fromEntries: function(e) {
	var t = {};
	return Jc(e, function(e, n) {
		Yc(t, e, n);
	}, { AS_ENTRIES: !0 }), t;
} });
var Xc = E.Object.fromEntries, Zc = {
	CSSRuleList: 0,
	CSSStyleDeclaration: 0,
	CSSValueList: 0,
	ClientRectList: 0,
	DOMRectList: 0,
	DOMStringList: 0,
	DOMTokenList: 1,
	DataTransferItemList: 0,
	FileList: 0,
	HTMLAllCollection: 0,
	HTMLCollection: 0,
	HTMLFormElement: 0,
	HTMLSelectElement: 0,
	MediaList: 0,
	MimeTypeArray: 0,
	NamedNodeMap: 0,
	NodeList: 1,
	PaintRequestList: 0,
	Plugin: 0,
	PluginArray: 0,
	SVGLengthList: 0,
	SVGNumberList: 0,
	SVGPathSegList: 0,
	SVGPointList: 0,
	SVGStringList: 0,
	SVGTransformList: 0,
	SourceBufferList: 0,
	StyleSheetList: 0,
	TextTrackCueList: 0,
	TextTrackList: 0,
	TouchList: 0
}, Qc = m, $c = Jr, el = N, tl = R, nl = A("toStringTag");
for (var rl in Zc) {
	var il = Qc[rl], al = il && il.prototype;
	al && $c(al) !== nl && el(al, nl, rl), tl[rl] = tl.Array;
}
var ol = /*@__PURE__*/ i(Xc), sl = a, cl = A, ll = Ge, ul = cl("species"), dl = function(e) {
	return ll >= 51 || !sl(function() {
		var t = [], n = t.constructor = {};
		return n[ul] = function() {
			return { foo: 1 };
		}, t[e](Boolean).foo !== 1;
	});
}, fl = I, pl = Xi.map;
fl({
	target: "Array",
	proto: !0,
	forced: !dl("map")
}, { map: function(e) {
	return pl(this, e, arguments.length > 1 ? arguments[1] : void 0);
} });
var ml = Ar("Array").map, hl = f, gl = ml, _l = Array.prototype, vl = /*@__PURE__*/ i(function(e) {
	var t = e.map;
	return e === _l || hl(_l, e) && t === _l.map ? gl : t;
}), yl = { exports: {} }, bl = {}, xl = oo, Sl = so.concat("length", "prototype");
bl.f = Object.getOwnPropertyNames || function(e) {
	return xl(e, Sl);
};
var Cl = {}, wl = gr, Tl = xr, El = Kc, Dl = Array, Ol = Math.max, kl = function(e, t, n) {
	for (var r = Tl(e), i = wl(t, r), a = wl(n === void 0 ? r : n, r), o = Dl(Ol(a - i, 0)), s = 0; i < a; i++, s++) El(o, s, e[i]);
	return o.length = s, o;
}, Al = b, jl = w, Ml = bl.f, Nl = kl, Pl = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [], Fl = function(e) {
	try {
		return Ml(e);
	} catch {
		return Nl(Pl);
	}
};
Cl.f = function(e) {
	return Pl && Al(e) === "Window" ? Fl(e) : Ml(jl(e));
};
var Il = a(function() {
	if (typeof ArrayBuffer == "function") {
		var e = /* @__PURE__ */ new ArrayBuffer(8);
		Object.isExtensible(e) && Object.defineProperty(e, "a", { value: 8 });
	}
}), Ll = a, Rl = T, zl = b, Bl = Il, Vl = Object.isExtensible, Hl = Ll(function() {
	Vl(1);
}) || Bl ? function(e) {
	return !Rl(e) || Bl && zl(e) === "ArrayBuffer" ? !1 : !Vl || Vl(e);
} : Vl, Ul = !a(function() {
	return Object.isExtensible(Object.preventExtensions({}));
}), Wl = I, Gl = d, Kl = ka, ql = T, Jl = O, Yl = j.f, Xl = bl, Zl = Cl, Ql = Hl, $l = Lt, eu = Ul, tu = !1, H = $l("meta"), nu = 0, ru = function(e) {
	Yl(e, H, { value: {
		objectID: "O" + nu++,
		weakData: {}
	} });
}, iu = yl.exports = {
	enable: function() {
		iu.enable = function() {}, tu = !0;
		var e = Xl.f, t = Gl([].splice), n = {};
		n[H] = 1, e(n).length && (Xl.f = function(n) {
			for (var r = e(n), i = 0, a = r.length; i < a; i++) if (r[i] === H) {
				t(r, i, 1);
				break;
			}
			return r;
		}, Wl({
			target: "Object",
			stat: !0,
			forced: !0
		}, { getOwnPropertyNames: Zl.f }));
	},
	fastKey: function(e, t) {
		if (!ql(e)) return typeof e == "symbol" ? e : (typeof e == "string" ? "S" : "P") + e;
		if (!Jl(e, H)) {
			if (!Ql(e)) return "F";
			if (!t) return "E";
			ru(e);
		}
		return e[H].objectID;
	},
	getWeakData: function(e, t) {
		if (!Jl(e, H)) {
			if (!Ql(e)) return !0;
			if (!t) return !1;
			ru(e);
		}
		return e[H].weakData;
	},
	onFreeze: function(e) {
		return eu && tu && Ql(e) && !Jl(e, H) && ru(e), e;
	}
};
Kl[H] = !0;
var au = yl.exports, ou = f, su = TypeError, cu = function(e, t) {
	if (ou(t, e)) return e;
	throw su("Incorrect invocation");
}, lu = I, uu = m, du = au, fu = a, pu = N, mu = Hc, hu = cu, gu = x, _u = T, vu = Ce, yu = gs, bu = j.f, xu = Xi.forEach, Su = S, Cu = Ka, wu = Cu.set, Tu = Cu.getterFor, Eu = function(e, t, n) {
	var r = e.indexOf("Map") !== -1, i = e.indexOf("Weak") !== -1, a = r ? "set" : "add", o = uu[e], s = o && o.prototype, c = {}, l;
	if (!Su || !gu(o) || !(i || s.forEach && !fu(function() {
		new o().entries().next();
	}))) l = n.getConstructor(t, e, r, a), du.enable();
	else {
		l = t(function(t, n) {
			wu(hu(t, u), {
				type: e,
				collection: new o()
			}), vu(n) || mu(n, t[a], {
				that: t,
				AS_ENTRIES: r
			});
		});
		var u = l.prototype, d = Tu(e);
		xu([
			"add",
			"clear",
			"delete",
			"forEach",
			"get",
			"has",
			"set",
			"keys",
			"values",
			"entries"
		], function(e) {
			var t = e === "add" || e === "set";
			e in s && !(i && e === "clear") && pu(u, e, function(n, r) {
				var a = d(this).collection;
				if (!t && i && !_u(n)) return e === "get" && void 0;
				var o = a[e](n === 0 ? 0 : n, r);
				return t ? this : o;
			});
		}), i || bu(u, "size", {
			configurable: !0,
			get: function() {
				return d(this).collection.size;
			}
		});
	}
	return yu(l, e, !1, !0), c[e] = l, lu({
		global: !0,
		forced: !0
	}, c), i || n.setStrong(l, e, r), l;
}, Du = j, Ou = function(e, t, n) {
	return Du.f(e, t, n);
}, ku = Yo, Au = function(e, t, n) {
	for (var r in t) n && n.unsafe && e[r] ? e[r] = t[r] : ku(e, r, t[r], n);
	return e;
}, ju = Ie, Mu = Ou, Nu = A, Pu = S, Fu = Nu("species"), Iu = function(e) {
	var t = ju(e);
	Pu && t && !t[Fu] && Mu(t, Fu, {
		configurable: !0,
		get: function() {
			return this;
		}
	});
}, Lu = Lo, Ru = Ou, zu = Au, Bu = Fn, Vu = cu, Hu = Ce, Uu = Hc, Wu = Zs, Gu = Qs, Ku = Iu, qu = S, Ju = au.fastKey, Yu = Ka, Xu = Yu.set, Zu = Yu.getterFor;
Eu("Set", function(e) {
	return function() {
		return e(this, arguments.length ? arguments[0] : void 0);
	};
}, {
	getConstructor: function(e, t, n, r) {
		var i = e(function(e, i) {
			Vu(e, a), Xu(e, {
				type: t,
				index: Lu(null),
				first: void 0,
				last: void 0,
				size: 0
			}), qu || (e.size = 0), Hu(i) || Uu(i, e[r], {
				that: e,
				AS_ENTRIES: n
			});
		}), a = i.prototype, o = Zu(t), s = function(e, t, n) {
			var r = o(e), i = c(e, t), a, s;
			return i ? i.value = n : (r.last = i = {
				index: s = Ju(t, !0),
				key: t,
				value: n,
				previous: a = r.last,
				next: void 0,
				removed: !1
			}, r.first ||= i, a && (a.next = i), qu ? r.size++ : e.size++, s !== "F" && (r.index[s] = i)), e;
		}, c = function(e, t) {
			var n = o(e), r = Ju(t), i;
			if (r !== "F") return n.index[r];
			for (i = n.first; i; i = i.next) if (i.key === t) return i;
		};
		return zu(a, {
			clear: function() {
				for (var e = this, t = o(e), n = t.index, r = t.first; r;) r.removed = !0, r.previous &&= r.previous.next = void 0, delete n[r.index], r = r.next;
				t.first = t.last = void 0, qu ? t.size = 0 : e.size = 0;
			},
			delete: function(e) {
				var t = this, n = o(t), r = c(t, e);
				if (r) {
					var i = r.next, a = r.previous;
					delete n.index[r.index], r.removed = !0, a && (a.next = i), i && (i.previous = a), n.first === r && (n.first = i), n.last === r && (n.last = a), qu ? n.size-- : t.size--;
				}
				return !!r;
			},
			forEach: function(e) {
				for (var t = o(this), n = Bu(e, arguments.length > 1 ? arguments[1] : void 0), r; r = r ? r.next : t.first;) for (n(r.value, r.key, this); r && r.removed;) r = r.previous;
			},
			has: function(e) {
				return !!c(this, e);
			}
		}), zu(a, n ? {
			get: function(e) {
				var t = c(this, e);
				return t && t.value;
			},
			set: function(e, t) {
				return s(this, e === 0 ? 0 : e, t);
			}
		} : { add: function(e) {
			return s(this, e = e === 0 ? 0 : e, e);
		} }), qu && Ru(a, "size", {
			configurable: !0,
			get: function() {
				return o(this).size;
			}
		}), i;
	},
	setStrong: function(e, t, n) {
		var r = t + " Iterator", i = Zu(t), a = Zu(r);
		Wu(e, t, function(e, t) {
			Xu(this, {
				type: r,
				target: e,
				state: i(e),
				kind: t,
				last: void 0
			});
		}, function() {
			for (var e = a(this), t = e.kind, n = e.last; n && n.removed;) n = n.previous;
			return !e.target || !(e.last = n = n ? n.next : e.state.first) ? (e.target = void 0, Gu(void 0, !0)) : Gu(t === "keys" ? n.key : t === "values" ? n.value : [n.key, n.value], !1);
		}, n ? "entries" : "values", !n, !0), Ku(t);
	}
});
var Qu = d, $u = fr, ed = Zr, td = Ee, nd = Qu("".charAt), rd = Qu("".charCodeAt), id = Qu("".slice), ad = { charAt: function(e) {
	return function(t, n) {
		var r = ed(td(t)), i = $u(n), a = r.length, o, s;
		return i < 0 || i >= a ? e ? "" : void 0 : (o = rd(r, i), o < 55296 || o > 56319 || i + 1 === a || (s = rd(r, i + 1)) < 56320 || s > 57343 ? e ? nd(r, i) : o : e ? id(r, i, i + 2) : (o - 55296 << 10) + (s - 56320) + 65536);
	};
}(!0) }.charAt, od = Zr, sd = Ka, cd = Zs, ld = Qs, ud = "String Iterator", dd = sd.set, fd = sd.getterFor(ud);
cd(String, "String", function(e) {
	dd(this, {
		type: ud,
		string: od(e),
		index: 0
	});
}, function() {
	var e = fd(this), t = e.string, n = e.index, r;
	return n >= t.length ? ld(void 0, !0) : (r = ad(t, n), e.index += r.length, ld(r, !1));
});
var pd = E.Set, md = /*@__PURE__*/ i(pd), hd = S, gd = a, _d = d, vd = qo, yd = uo, bd = w, xd = pe.f, Sd = _d(xd), Cd = _d([].push), wd = hd && gd(function() {
	var e = Object.create(null);
	return e[2] = 2, !Sd(e, 2);
}), Td = function(e) {
	return function(t) {
		for (var n = bd(t), r = yd(n), i = wd && vd(n) === null, a = r.length, o = 0, s = [], c; a > o;) c = r[o++], (!hd || (i ? c in n : Sd(n, c))) && Cd(s, e ? [c, n[c]] : n[c]);
		return s;
	};
}, Ed = {
	entries: Td(!0),
	values: Td(!1)
}, Dd = I, Od = Ed.values;
Dd({
	target: "Object",
	stat: !0
}, { values: function(e) {
	return Od(e);
} });
var kd = E.Object.values, Ad = /*@__PURE__*/ i(kd), jd = I, Md = Ed.entries;
jd({
	target: "Object",
	stat: !0
}, { entries: function(e) {
	return Md(e);
} });
var Nd = E.Object.entries, Pd = /*@__PURE__*/ i(Nd), Fd = [
	"prod",
	"stag",
	"stag2",
	"dev1",
	"preprod"
], Id = ol(vl(Fd).call(Fd, (e) => [e, e === "prod" ? "dixa.io" : `euw1.${e}.dixa.io`]));
function Ld(e) {
	return new md(Ad(Id)).has(e);
}
function Rd(e) {
	if (!e) return "prod";
	for (let [t, n] of Pd(Id)) if (e === n) return t;
	return "prod";
}
function zd(e) {
	e = e.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
	let t = RegExp(`[\\?&]${e}=([^&#]*)`).exec(location.search);
	return t === null ? null : Bd(t[1].replace(/\+/g, " "));
}
function Bd(e) {
	try {
		return decodeURIComponent(e);
	} catch {
		return console.warn(`Failed to decode param value '${e}'`), e;
	}
}
var Vd = { backendDomain: "dixa:backend-domain" };
function Hd() {
	let e = zd("staging") || zd("backend-domain");
	if (e) {
		let t = /^\d+$/.test(e) ? `euw1.stag${e === "1" ? "" : e}.dixa.io` : e;
		return Ld(t) ? (Wd(t), t) : null;
	}
	return null;
}
function Ud() {
	var e;
	let t = aa(e = document.cookie.split("; ")).call(e, (e) => ba(e).call(e, `${Vd.backendDomain}=`)), n = t ? decodeURIComponent(t.split("=")[1]) : null;
	return n && !Ld(n) ? (Gd(), null) : n;
}
function Wd(e) {
	document.cookie = `${Vd.backendDomain}=${encodeURIComponent(e)}; path=/; max-age=31536000; SameSite=Lax`;
}
function Gd() {
	document.cookie = `${Vd.backendDomain}=; path=/; max-age=0`;
}
var Kd, qd, Jd, Yd, Xd, Zd, U = window.location.origin.replace(/^https?:\/\//, ""), W = Hd() ?? Ud(), G = Rd(W), K = {
	develop: [
		"localhost:8080",
		"dixadev.com",
		"dixa.io"
	],
	test: {
		security: ["dixa-security.com", "dixa-security.net"],
		automation: [
			"localhost:9999",
			"test-agent-interface.dixa.io",
			"test.dixatest.com",
			"okta-test-org.dixatest.com"
		]
	},
	custom: [
		"thehaddaway.dixa.com",
		"demo.dixa.com",
		"developer.dixa.com",
		"okta-test.dixa.com",
		"development.dixa.com",
		"engineering.dixa.com"
	],
	default: {
		email: "dixa.com",
		emailIntegration: "email.dixa.io",
		integrations: "docs.dixa.io",
		service: "dixa.io",
		status: "status.dixa.io",
		subdomain: "demo",
		userContent: "dixausercontent.com",
		web: "dixa.com",
		accounts: "accounts.dixa.com",
		knowledge: "knowledge-backend-cdn",
		satisfactionSurveyPreview: "csat.reviews"
	}
}, Qd = {
	assets: `https://assets.${K.default.service}`,
	toolkit: `https://toolkit.${K.default.service}`,
	widget: `https://widget.${K.default.service}`,
	messenger: G === "prod" ? `https://messenger.${K.default.service}` : `https://messenger.${G}.${K.default.service}`,
	rest: `https://api.${W ?? K.default.service}`,
	advancedInsights: `https://api.${W ?? K.default.service}/v1/advanced-insights/`,
	partnerIntegrations: `https://partner-integrations.${W ?? K.default.service}`,
	files: `https://files.${W ?? K.default.service}`,
	webSocket: `wss://agent-sockets.${W ?? K.default.service}/v2/agent/`,
	userContent: W ? `https://raw.${W.replace(K.default.service, K.default.userContent)}` : `https://raw.${K.default.userContent}`,
	signUp: `https://${K.default.accounts}/signup`,
	logIn: `https://${K.default.accounts}/signin`,
	knowledgeCdn: G === "prod" ? `https://knowledge-backend-cdn.${K.default.service}` : `https://knowledge-backend-cdn.${G}.${K.default.service}`,
	knowledgeApi: `https://knowledge-backend.${W ?? K.default.service}`,
	satisfactionSurveyPreview: G === "prod" ? `https://${K.default.satisfactionSurveyPreview}/preview.html` : `https://stag.${K.default.satisfactionSurveyPreview}/preview.html`
}, $d = {
	amplitude: { environment: L(Kd = [
		...K.test.automation,
		...K.develop,
		...K.test.security,
		...K.custom
	]).call(Kd, U) || G !== "prod" ? "stag" : "prod" },
	launchDarkly: L(qd = K.develop).call(qd, U) ? "5ccbf1bfa9046808225e3998" : "5ccbf1bfa9046808225e3999",
	launchDarklyBackend: L(Jd = K.develop).call(Jd, U) ? "6058545ab95b560e51acf129" : "6058545ab95b560e51acf12a",
	launchDarklyMiuros: L(Yd = K.develop).call(Yd, U) ? "649ea8d43e6eca13a145c21f" : "649ea8d43e6eca13a145c220",
	stripe: L(Xd = K.develop).call(Xd, U) ? "pk_test_jNReMBzv4cyXIBkSUrqaFtd0" : "pk_live_0b40LYRePjPZTtN9E9NbKixl",
	elevio: "599d54aacd7bd",
	birdeatsbug: "eee2fdfc-e7ee-4698-95fd-20e8cb83a4d5",
	jabra: {
		partnerKey: "4d2f-9cba7bbd-a9dd-4703-9847-c70a7df516ba",
		appId: "Dixa",
		appName: "Dixa"
	},
	messenger: { token: {
		prod: L(Zd = K.develop).call(Zd, U) ? "95b2b555c0b046a18e5d508837811008" : "7c08132d4bf5d5f1bf4432133ef8254e3262f9ef",
		stag: "0a76a5650f3540dc8bad030e54aa2e22",
		stag2: "0a76a5650f3540dc8bad030e54aa2e22",
		dev1: "414a01b7802f4d4bb61a6ab6aaacd442",
		preprod: ""
	} }
}, ef = {
	environment: G,
	domain: K.default,
	sdk: $d,
	url: Qd,
	backendDomain: W
}, tf = new class {
	isElectron() {
		return window.electron ? !!window.electron : !!process?.versions?.electron || /electron/i.test(navigator.userAgent);
	}
	async getVersion() {
		return window.electron ? (await window.electron.getVersion()).split("-")[0] : "0.0.0";
	}
	async isStandaloneBuild() {
		return window.electron?.isStandaloneBuild ? await window.electron.isStandaloneBuild() : null;
	}
	async isMsiBuild() {
		return window.electron?.isMsiBuild ? await window.electron.isMsiBuild() : null;
	}
}();
//#endregion
//#region ../semver/dist/index.es.js
function nf(e, t) {
	return rf(e), rf(t), e.localeCompare(t, void 0, { numeric: !0 });
}
function rf(e) {
	if (e.split(".").length !== 3) throw Error(`The version '${e}' must be in the format 'x.x.x'.`);
}
//#endregion
//#region ../../../node_modules/@sentry/utils/build/esm/is.js
var af = Object.prototype.toString;
function of(e, t) {
	return af.call(e) === `[object ${t}]`;
}
function sf(e) {
	return of(e, "Object");
}
function cf(e) {
	return !!(e && e.then && typeof e.then == "function");
}
//#endregion
//#region ../../../node_modules/@sentry/utils/build/esm/version.js
var lf = "8.36.0", q = globalThis;
function uf(e, t, n) {
	let r = n || q, i = r.__SENTRY__ = r.__SENTRY__ || {}, a = i[lf] = i["8.36.0"] || {};
	return a[e] || (a[e] = t());
}
//#endregion
//#region ../../../node_modules/@sentry/utils/build/esm/debug-build.js
var df = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, ff = "Sentry Logger ", pf = [
	"debug",
	"info",
	"warn",
	"error",
	"log",
	"assert",
	"trace"
], mf = {};
function hf(e) {
	if (!("console" in q)) return e();
	let t = q.console, n = {}, r = Object.keys(mf);
	r.forEach((e) => {
		let r = mf[e];
		n[e] = t[e], t[e] = r;
	});
	try {
		return e();
	} finally {
		r.forEach((e) => {
			t[e] = n[e];
		});
	}
}
function gf() {
	let e = !1, t = {
		enable: () => {
			e = !0;
		},
		disable: () => {
			e = !1;
		},
		isEnabled: () => e
	};
	return df ? pf.forEach((n) => {
		t[n] = (...t) => {
			e && hf(() => {
				q.console[n](`${ff}[${n}]:`, ...t);
			});
		};
	}) : pf.forEach((e) => {
		t[e] = () => void 0;
	}), t;
}
var _f = uf("logger", gf);
//#endregion
//#region ../../../node_modules/@sentry/utils/build/esm/object.js
function vf(e, t, n) {
	try {
		Object.defineProperty(e, t, {
			value: n,
			writable: !0,
			configurable: !0
		});
	} catch {
		df && _f.log(`Failed to add non-enumerable property "${t}" to object`, e);
	}
}
//#endregion
//#region ../../../node_modules/@sentry/utils/build/esm/time.js
var yf = 1e3;
function bf() {
	return Date.now() / yf;
}
function xf() {
	let { performance: e } = q;
	if (!e || !e.now) return bf;
	let t = Date.now() - e.now(), n = e.timeOrigin == null ? t : e.timeOrigin;
	return () => (n + e.now()) / yf;
}
var Sf = xf();
(() => {
	let { performance: e } = q;
	if (!e || !e.now) return;
	let t = 3600 * 1e3, n = e.now(), r = Date.now(), i = e.timeOrigin ? Math.abs(e.timeOrigin + n - r) : t, a = i < t, o = e.timing && e.timing.navigationStart, s = typeof o == "number" ? Math.abs(o + n - r) : t;
	return a || s < t ? i <= s ? e.timeOrigin : o : r;
})();
//#endregion
//#region ../../../node_modules/@sentry/utils/build/esm/misc.js
function J() {
	let e = q, t = e.crypto || e.msCrypto, n = () => Math.random() * 16;
	try {
		if (t && t.randomUUID) return t.randomUUID().replace(/-/g, "");
		t && t.getRandomValues && (n = () => {
			let e = /* @__PURE__ */ new Uint8Array(1);
			return t.getRandomValues(e), e[0];
		});
	} catch {}
	return "10000000100040008000100000000000".replace(/[018]/g, (e) => (e ^ (n() & 15) >> e / 4).toString(16));
}
//#endregion
//#region ../../../node_modules/@sentry/utils/build/esm/propagationContext.js
function Cf() {
	return {
		traceId: J(),
		spanId: J().substring(16)
	};
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/carrier.js
function wf() {
	return Tf(q), q;
}
function Tf(e) {
	let t = e.__SENTRY__ = e.__SENTRY__ || {};
	return t.version = t.version || "8.36.0", t[lf] = t["8.36.0"] || {};
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/session.js
function Ef(e, t = {}) {
	if (t.user && (!e.ipAddress && t.user.ip_address && (e.ipAddress = t.user.ip_address), !e.did && !t.did && (e.did = t.user.id || t.user.email || t.user.username)), e.timestamp = t.timestamp || Sf(), t.abnormal_mechanism && (e.abnormal_mechanism = t.abnormal_mechanism), t.ignoreDuration && (e.ignoreDuration = t.ignoreDuration), t.sid && (e.sid = t.sid.length === 32 ? t.sid : J()), t.init !== void 0 && (e.init = t.init), !e.did && t.did && (e.did = `${t.did}`), typeof t.started == "number" && (e.started = t.started), e.ignoreDuration) e.duration = void 0;
	else if (typeof t.duration == "number") e.duration = t.duration;
	else {
		let t = e.timestamp - e.started;
		e.duration = t >= 0 ? t : 0;
	}
	t.release && (e.release = t.release), t.environment && (e.environment = t.environment), !e.ipAddress && t.ipAddress && (e.ipAddress = t.ipAddress), !e.userAgent && t.userAgent && (e.userAgent = t.userAgent), typeof t.errors == "number" && (e.errors = t.errors), t.status && (e.status = t.status);
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/utils/spanOnScope.js
var Df = "_sentrySpan";
function Of(e, t) {
	t ? vf(e, Df, t) : delete e[Df];
}
function kf(e) {
	return e[Df];
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/scope.js
var Af = 100, Y = class e {
	constructor() {
		this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = Cf();
	}
	clone() {
		let t = new e();
		return t._breadcrumbs = [...this._breadcrumbs], t._tags = { ...this._tags }, t._extra = { ...this._extra }, t._contexts = { ...this._contexts }, t._user = this._user, t._level = this._level, t._session = this._session, t._transactionName = this._transactionName, t._fingerprint = this._fingerprint, t._eventProcessors = [...this._eventProcessors], t._requestSession = this._requestSession, t._attachments = [...this._attachments], t._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, t._propagationContext = { ...this._propagationContext }, t._client = this._client, t._lastEventId = this._lastEventId, Of(t, kf(this)), t;
	}
	setClient(e) {
		this._client = e;
	}
	setLastEventId(e) {
		this._lastEventId = e;
	}
	getClient() {
		return this._client;
	}
	lastEventId() {
		return this._lastEventId;
	}
	addScopeListener(e) {
		this._scopeListeners.push(e);
	}
	addEventProcessor(e) {
		return this._eventProcessors.push(e), this;
	}
	setUser(e) {
		return this._user = e || {
			email: void 0,
			id: void 0,
			ip_address: void 0,
			username: void 0
		}, this._session && Ef(this._session, { user: e }), this._notifyScopeListeners(), this;
	}
	getUser() {
		return this._user;
	}
	getRequestSession() {
		return this._requestSession;
	}
	setRequestSession(e) {
		return this._requestSession = e, this;
	}
	setTags(e) {
		return this._tags = {
			...this._tags,
			...e
		}, this._notifyScopeListeners(), this;
	}
	setTag(e, t) {
		return this._tags = {
			...this._tags,
			[e]: t
		}, this._notifyScopeListeners(), this;
	}
	setExtras(e) {
		return this._extra = {
			...this._extra,
			...e
		}, this._notifyScopeListeners(), this;
	}
	setExtra(e, t) {
		return this._extra = {
			...this._extra,
			[e]: t
		}, this._notifyScopeListeners(), this;
	}
	setFingerprint(e) {
		return this._fingerprint = e, this._notifyScopeListeners(), this;
	}
	setLevel(e) {
		return this._level = e, this._notifyScopeListeners(), this;
	}
	setTransactionName(e) {
		return this._transactionName = e, this._notifyScopeListeners(), this;
	}
	setContext(e, t) {
		return t === null ? delete this._contexts[e] : this._contexts[e] = t, this._notifyScopeListeners(), this;
	}
	setSession(e) {
		return e ? this._session = e : delete this._session, this._notifyScopeListeners(), this;
	}
	getSession() {
		return this._session;
	}
	update(e) {
		if (!e) return this;
		let t = typeof e == "function" ? e(this) : e, [n, r] = t instanceof Y ? [t.getScopeData(), t.getRequestSession()] : sf(t) ? [e, e.requestSession] : [], { tags: i, extra: a, user: o, contexts: s, level: c, fingerprint: l = [], propagationContext: u } = n || {};
		return this._tags = {
			...this._tags,
			...i
		}, this._extra = {
			...this._extra,
			...a
		}, this._contexts = {
			...this._contexts,
			...s
		}, o && Object.keys(o).length && (this._user = o), c && (this._level = c), l.length && (this._fingerprint = l), u && (this._propagationContext = u), r && (this._requestSession = r), this;
	}
	clear() {
		return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._session = void 0, Of(this, void 0), this._attachments = [], this._propagationContext = Cf(), this._notifyScopeListeners(), this;
	}
	addBreadcrumb(e, t) {
		let n = typeof t == "number" ? t : Af;
		if (n <= 0) return this;
		let r = {
			timestamp: bf(),
			...e
		}, i = this._breadcrumbs;
		return i.push(r), this._breadcrumbs = i.length > n ? i.slice(-n) : i, this._notifyScopeListeners(), this;
	}
	getLastBreadcrumb() {
		return this._breadcrumbs[this._breadcrumbs.length - 1];
	}
	clearBreadcrumbs() {
		return this._breadcrumbs = [], this._notifyScopeListeners(), this;
	}
	addAttachment(e) {
		return this._attachments.push(e), this;
	}
	clearAttachments() {
		return this._attachments = [], this;
	}
	getScopeData() {
		return {
			breadcrumbs: this._breadcrumbs,
			attachments: this._attachments,
			contexts: this._contexts,
			tags: this._tags,
			extra: this._extra,
			user: this._user,
			level: this._level,
			fingerprint: this._fingerprint || [],
			eventProcessors: this._eventProcessors,
			propagationContext: this._propagationContext,
			sdkProcessingMetadata: this._sdkProcessingMetadata,
			transactionName: this._transactionName,
			span: kf(this)
		};
	}
	setSDKProcessingMetadata(e) {
		return this._sdkProcessingMetadata = {
			...this._sdkProcessingMetadata,
			...e
		}, this;
	}
	setPropagationContext(e) {
		return this._propagationContext = e, this;
	}
	getPropagationContext() {
		return this._propagationContext;
	}
	captureException(e, t) {
		let n = t && t.event_id ? t.event_id : J();
		if (!this._client) return _f.warn("No client configured on scope - will not capture exception!"), n;
		let r = /* @__PURE__ */ Error("Sentry syntheticException");
		return this._client.captureException(e, {
			originalException: e,
			syntheticException: r,
			...t,
			event_id: n
		}, this), n;
	}
	captureMessage(e, t, n) {
		let r = n && n.event_id ? n.event_id : J();
		if (!this._client) return _f.warn("No client configured on scope - will not capture message!"), r;
		let i = Error(e);
		return this._client.captureMessage(e, t, {
			originalException: e,
			syntheticException: i,
			...n,
			event_id: r
		}, this), r;
	}
	captureEvent(e, t) {
		let n = t && t.event_id ? t.event_id : J();
		return this._client ? (this._client.captureEvent(e, {
			...t,
			event_id: n
		}, this), n) : (_f.warn("No client configured on scope - will not capture event!"), n);
	}
	_notifyScopeListeners() {
		this._notifyingListeners ||= (this._notifyingListeners = !0, this._scopeListeners.forEach((e) => {
			e(this);
		}), !1);
	}
};
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/defaultScopes.js
function jf() {
	return uf("defaultCurrentScope", () => new Y());
}
function Mf() {
	return uf("defaultIsolationScope", () => new Y());
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/asyncContext/stackStrategy.js
var Nf = class {
	constructor(e, t) {
		let n;
		n = e || new Y();
		let r;
		r = t || new Y(), this._stack = [{ scope: n }], this._isolationScope = r;
	}
	withScope(e) {
		let t = this._pushScope(), n;
		try {
			n = e(t);
		} catch (e) {
			throw this._popScope(), e;
		}
		return cf(n) ? n.then((e) => (this._popScope(), e), (e) => {
			throw this._popScope(), e;
		}) : (this._popScope(), n);
	}
	getClient() {
		return this.getStackTop().client;
	}
	getScope() {
		return this.getStackTop().scope;
	}
	getIsolationScope() {
		return this._isolationScope;
	}
	getStackTop() {
		return this._stack[this._stack.length - 1];
	}
	_pushScope() {
		let e = this.getScope().clone();
		return this._stack.push({
			client: this.getClient(),
			scope: e
		}), e;
	}
	_popScope() {
		return this._stack.length <= 1 ? !1 : !!this._stack.pop();
	}
};
function X() {
	let e = Tf(wf());
	return e.stack = e.stack || new Nf(jf(), Mf());
}
function Pf(e) {
	return X().withScope(e);
}
function Ff(e, t) {
	let n = X();
	return n.withScope(() => (n.getStackTop().scope = e, t(e)));
}
function If(e) {
	return X().withScope(() => e(X().getIsolationScope()));
}
function Lf() {
	return {
		withIsolationScope: If,
		withScope: Pf,
		withSetScope: Ff,
		withSetIsolationScope: (e, t) => If(t),
		getCurrentScope: () => X().getScope(),
		getIsolationScope: () => X().getIsolationScope()
	};
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/asyncContext/index.js
function Rf(e) {
	let t = Tf(e);
	return t.acs ? t.acs : Lf();
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/currentScopes.js
function zf() {
	return Rf(wf()).getCurrentScope();
}
function Bf() {
	return Rf(wf()).getIsolationScope();
}
function Vf() {
	return zf().getClient();
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/utils/prepareEvent.js
function Hf(e) {
	if (e) return Uf(e) || Gf(e) ? { captureContext: e } : e;
}
function Uf(e) {
	return e instanceof Y || typeof e == "function";
}
var Wf = [
	"user",
	"level",
	"extra",
	"contexts",
	"tags",
	"fingerprint",
	"requestSession",
	"propagationContext"
];
function Gf(e) {
	return Object.keys(e).some((e) => Wf.includes(e));
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/exports.js
function Kf(e, t) {
	return zf().captureException(e, Hf(t));
}
function qf(e, t) {
	let n = typeof t == "string" ? t : void 0, r = typeof t == "string" ? void 0 : { captureContext: t };
	return zf().captureMessage(e, n, r);
}
function Jf(e, t) {
	Bf().setContext(e, t);
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/breadcrumbs.js
var Yf = 100;
function Z(e, t) {
	let n = Vf(), r = Bf();
	if (!n) return;
	let { beforeBreadcrumb: i = null, maxBreadcrumbs: a = Yf } = n.getOptions();
	if (a <= 0) return;
	let o = {
		timestamp: bf(),
		...e
	}, s = i ? hf(() => i(o, t)) : o;
	s !== null && (n.emit && n.emit("beforeAddBreadcrumb", s, t), r.addBreadcrumb(s, a));
}
//#endregion
//#region ../sentry/dist/index.js
var Xf;
(function(e) {
	e.Unknown = "unknown", e.Core = "core", e.Routing = "routing-and-presence", e.Insights = "insights", e.Ecosystem = "ecosystem", e.Partners = "partners", e.Channels = "channels", e.Messaging = "messaging", e.Platform = "platform", e.AI = "ai", e.Conversations = "conversations", e.Automation = "automation";
})(Xf ||= {});
//#endregion
//#region ../auth/dist/jwt/jwt.js
function Zf(e) {
	let t = e.split(".")[1];
	if (!t) throw Error("Invalid token");
	let n = t.replace(/-/g, "+").replace(/_/g, "/");
	try {
		return JSON.parse(Buffer.from(n, "base64").toString());
	} catch (e) {
		throw Error(`Failed to parse the JSON Web Token with the following error: ${e}`);
	}
}
//#endregion
//#region ../auth/dist/redirect/redirect.js
var Qf = ef.backendDomain ? { "backend-domain": ef.backendDomain } : void 0;
function $f() {
	let e = new URLSearchParams({
		noToken: "true",
		...Qf
	}).toString();
	document.location.href = `${ef.url.logIn}?${e}`;
}
//#endregion
//#region ../auth/dist/authManager/authStorageConfig.js
var ep = "authData", tp = 600, np = 5, Q = new class {
	authData = null;
	accessTokenExpiresAt = 0;
	clientServerTimeDiff = 0;
	estimatedServerTime() {
		let e = Date.now() / 1e3;
		return this.clientServerTimeDiff >= np || this.clientServerTimeDiff <= -5 ? Math.ceil(e + this.clientServerTimeDiff) : Math.ceil(e);
	}
	setAuthData(e) {
		this.authData = e;
		let t = Math.ceil(Date.now() / 1e3) + tp, n = Zf(e.access_token).exp;
		if (this.clientServerTimeDiff = n - t, process.env.NODE_ENV !== "test" && Math.abs(this.clientServerTimeDiff) > np) {
			let e = this.clientServerTimeDiff > 0 ? "behind" : "ahead";
			console.info(`Client time is ${e} by significant amount. (${Math.abs(this.clientServerTimeDiff)}s)`);
		}
		this.accessTokenExpiresAt = n, localStorage.setItem(ep, JSON.stringify(e));
	}
	getAuthData() {
		if (this.authData) return this.authData;
		let e = localStorage.getItem(ep), t = e ? JSON.parse(e) : null;
		return this.validateAuthDataComplete(t) && (this.authData = t), t;
	}
	removeAuthData() {
		this.authData = null, localStorage.removeItem(ep);
	}
	getAccessToken() {
		return this.authData?.access_token || null;
	}
	getRefreshToken() {
		return this.authData?.refresh_token || null;
	}
	validateAuthDataComplete(e) {
		return e ? [
			"access_token",
			"refresh_token",
			"expires_in"
		].every((t) => e[t] !== void 0) : !1;
	}
	isAccessTokenExpired() {
		if (!this.getAccessToken()) return !0;
		let e = this.accessTokenExpiresAt - 30;
		return this.estimatedServerTime() >= e;
	}
	isRefreshTokenExpired(e) {
		if (!e) return !0;
		let t = Zf(e), n = t.exp - 30;
		return !t || this.estimatedServerTime() >= n;
	}
	accessTokenExpiresInMs() {
		return (this.accessTokenExpiresAt - 30 - this.estimatedServerTime()) * 1e3;
	}
}();
//#endregion
//#region ../auth/dist/authManager/interceptor.js
async function rp(e) {
	let t = window.location.origin.replace(/^https?:\/\//, "");
	if (!(!e.response || ["localhost:8080", "uptrends-monitor"].some((e) => t.includes(e)))) {
		try {
			let t = e.response.config.headers.Authorization ?? "", n = t ? t.toString()?.split("Basic ")[1] : "", r = n ? atob(n).split("token:")[1] : "", i = r ? Zf(r).exp : "None", a = await fp.getAuthData({ localStorageOnly: !0 }), o = Math.floor(Date.now() / 1e3), s = a?.access_token, c = a?.refresh_token, l = s ? Zf(s).exp : "None", u = c ? Zf(c).exp : "None", d = typeof i == "number" ? o - i : "Unknown", f = typeof l == "number" ? o - l : "Unknown", p = typeof u == "number" ? o - u : "Unknown", m = e.response.headers["x-dixa-rid"];
			Jf("Expires", {
				currentTimestamp: o,
				accessTokenFromHeader: i,
				accessTokenFromHeaderDiff: d,
				accessTokenFromLocalStorage: l,
				accessTokenFromLocalStorageDiff: f,
				refreshTokenFromLocalStorage: u,
				refreshTokenFromLocalStorageDiff: p,
				xDixaRid: m,
				navigatorOnline: navigator.onLine
			});
		} catch (e) {
			console.error("Error adding Sentry error context", e);
		}
		qf("401 unauthorized interceptor", {
			level: "debug",
			tags: {
				team: Xf.Platform,
				domain: t
			}
		});
	}
}
var ip = /* @__PURE__ */ new Map(), ap = 3;
function op(e) {
	e.interceptors.response.use((e) => (ip.delete(e.config.url), e), (t) => {
		if (t.response) {
			let { status: n } = t.response;
			switch (n) {
				case pp.Unauthorized:
					if (!fp.isRefreshTokenExpired() && t.config) {
						Z({
							category: "errorInterceptor",
							message: "Access token expired after request",
							level: "debug"
						});
						let n = ip.get(t.config.url) ?? 0;
						if (console.log(`Retrying request (${n + 1}): ${t.config.url}`), n <= ap) return ip.set(t.config.url, n + 1), e(t.config);
					}
					rp(t), console.error("401 unauthorized interceptor"), $f();
					break;
			}
		}
		return Promise.reject(t);
	});
}
//#endregion
//#region ../auth/dist/authManager/authManager.js
var sp = e.create();
op(sp);
var $ = console.log;
async function cp(e) {
	return new Promise((t) => setTimeout(t, e * 1e3));
}
var lp = class extends Error {
	constructor(e, t) {
		super(e, t);
	}
};
function up(e = 0) {
	return Math.min(Math.round((Math.random() + 1) * 1.5 ** e), 30);
}
var dp = 5, fp = new class {
	authDataPromise = null;
	retryCount = 0;
	async init(e) {
		let t = await this.refresh(e);
		if (t) Q.setAuthData(t);
		else throw new lp("Failed to init refresh token", { cause: Q.isRefreshTokenExpired(e) ? "expired" : "unknown" });
	}
	getDebugInfo() {
		let e = Q.getAccessToken();
		if (!e) return {};
		let { exp: t } = Zf(e);
		return {
			expire: t ? (/* @__PURE__ */ new Date(t * 1e3)).toISOString() : null,
			now: (/* @__PURE__ */ new Date()).toISOString()
		};
	}
	async getAuthData({ localStorageOnly: e = !1 } = {}) {
		if (e) return Q.getAuthData();
		if (this.authDataPromise) return await this.authDataPromise;
		let t = Q.getAuthData();
		return t ? Q.isAccessTokenExpired() ? (Z({
			category: "refreshToken",
			message: "expired or about to expire",
			level: "debug",
			data: this.getDebugInfo()
		}), this.authDataPromise = this.refresh(t.refresh_token).then((e) => (e && Q.setAuthData(e), this.authDataPromise = null, e)), await this.authDataPromise) : t : null;
	}
	removeAuthData() {
		return Q.removeAuthData();
	}
	validateAuthDataComplete(e) {
		return Q.validateAuthDataComplete(e);
	}
	isAccessTokenExpired() {
		return Q.isAccessTokenExpired();
	}
	isRefreshTokenExpired() {
		let e = Q.getAuthData();
		return !e || Q.isRefreshTokenExpired(e.refresh_token);
	}
	async isSupported() {
		return !tf.isElectron() || nf(await tf.getVersion(), "3.7.0") === 1;
	}
	async refresh(e, t = dp) {
		try {
			return await sp.post(`${ef.url.rest}/v2/login/refresh`, { refreshToken: e }).then((e) => (this.retryCount = 0, e.data.data));
		} catch (n) {
			return await this.handleRefreshError(n, e, t);
		}
	}
	async waitUntilOnline() {
		let e = navigator.onLine === !1;
		for (e && ($("AUTH", "Network connection offline - waiting..."), Z({
			category: "refreshToken",
			message: "Network connection offline - waiting...",
			level: "debug"
		})); navigator.onLine === !1;) await cp(5);
		e && ($("AUTH", "Network connection restored"), Z({
			category: "refreshToken",
			message: "Network connection restored",
			level: "debug"
		}));
	}
	async retryRefresh(e, t) {
		await this.waitUntilOnline(), this.retryCount++;
		let n = up(this.retryCount);
		return $("AUTH", `Retrying in ${n} seconds`), await cp(n), await this.refresh(e, t);
	}
	async handleRefreshError(e, n, r) {
		if (Q.isRefreshTokenExpired(n)) return $("AUTH", "Refresh token expired"), Z({
			category: "refreshToken",
			message: "Refresh token expired",
			level: "debug"
		}), Q.removeAuthData(), $f(), null;
		if (t(e)) {
			if (e.message === "timeout exceeded") return $("AUTH", "Timeout exceeded"), Z({
				category: "refreshToken",
				message: "Timeout exceeded",
				level: "debug"
			}), await this.retryRefresh(n, r);
			if (e.message === "Network Error") return $("AUTH", "Network error"), Z({
				category: "refreshToken",
				message: "Network error",
				level: "debug"
			}), await this.retryRefresh(n, r);
			if (e.response?.status === 401) return $("AUTH", "Refresh token invalid (401)"), Q.removeAuthData(), $f(), null;
			Kf(e, {
				level: "error",
				tags: {
					team: Xf.Platform,
					errorSource: "authManager.refresh"
				}
			});
		}
		return r <= 0 ? ($("AUTH", "Retries exhausted, logging out"), Kf(e, {
			level: "error",
			tags: {
				team: Xf.Platform,
				errorSource: "authManager.refresh"
			}
		}), Q.removeAuthData(), $f(), null) : ($("AUTH", `Retrying ${r} more times`), await this.retryRefresh(n, r - 1));
	}
	accessTokenExpiresInMs() {
		return Q.accessTokenExpiresInMs();
	}
}(), pp;
(function(e) {
	e[e.BadRequest = 400] = "BadRequest", e[e.Unauthorized = 401] = "Unauthorized", e[e.Forbidden = 403] = "Forbidden", e[e.NotFound = 404] = "NotFound", e[e.Conflict = 409] = "Conflict", e[e.InternalServerError = 500] = "InternalServerError", e[e.BadGateway = 502] = "BadGateway", e[e.ServiceUnavailable = 503] = "ServiceUnavailable";
})(pp ||= {});
//#endregion
//#region src/accessControl.ts
var mp = e.create(), hp = new class {
	user = null;
	scopes = null;
	_roles = null;
	get isInitialized() {
		return this.user !== null;
	}
	async init({ user: e }) {
		this.user = e;
		let t = await this.introspectAccessToken();
		t && (this.scopes = t.scope, this._roles = t.roles);
	}
	get roles() {
		return this._roles;
	}
	hasAccess(e, t) {
		if (!this.isInitialized || this.scopes === null) return !1;
		if (Array.isArray(e)) {
			let { strategy: n = "all" } = t ?? {};
			return n === "all" ? e.every(this.hasScope) : e.some(this.hasScope);
		}
		return this.scopes.includes(e);
	}
	hasScope = (e) => this.scopes.includes(e);
	async introspectAccessToken() {
		let e = await fp.getAuthData({ localStorageOnly: !0 });
		if (!e) return null;
		try {
			return (await mp.post(`${ef.url.rest}/v1/introspect`, { token: e.access_token }, { transformResponse: (e) => {
				let t = JSON.parse(e);
				return {
					...t,
					scope: t.scope ? t.scope.split(" ") : []
				};
			} })).data;
		} catch {
			return null;
		}
	}
	reset() {
		this.user = null, this.scopes = null, this._roles = null;
	}
}(), gp = (e, t) => n(() => hp.hasAccess(e, t), []);
//#endregion
export { hp as accessControl, gp as useHasAccess };

//# sourceMappingURL=index.js.map